import { Card, Col, Row } from "antd";

import React, { useState } from "react";
import UsefulMessage from "../../../../components/common/UsefulMessage";

const message = (
  <p>
    The late fee policy for this tenant is set by the{" "}
    <span className="onclick-text">property</span>.{" "}
    <span className="onclick-text">Create a policy</span> for this tenant.
  </p>
);

function LateFeePolicy() {
  const [checked, setChecked] = useState(false);
  return (
    <Card
      title="Late Fee Policy"
      extra={
        !checked ? (
          <span className="onclick-text" onClick={() => setChecked(true)}>
            Edit
          </span>
        ) : null
      }
    >
      <Row gutter={[0, 16]}>
        <Col span={24}>
          <strong>Current Late Fee Policy</strong>
        </Col>
        <Col span={24}>
          <UsefulMessage message={message} />
        </Col>
      </Row>
    </Card>
  );
}

export default LateFeePolicy;
